// extracted by mini-css-extract-plugin
export default {"avatarBadge":"_vTcm3F3I_YPg3zMEHQ_","avatarMultipleBadge":"crBuxkvDTb9m2MydUVkE"};